<template>
  <div class="product-checkout">
    <a-spin :spinning="loading" size="large">
      <a-card title="TrueLife Shop" class="style4 store">
        <a-row :gutter="16">
          <a-col :span="8">
            <div class="product-container">
              <a-card hoverable>
                <img slot="cover" :alt="product.name" :src="product.thumbnail" />
              </a-card>

              <a-row v-if="product.images" type="flex" justify="center" :gutter="[16, 4]" class="product-preview">
                <a-col v-for="(item, index) in product.images" :span="6" :key="index">
                  <a-tooltip :title="'Image ' + (index + 1)">
                    <a-card hoverable>
                      <img slot="cover" :alt="index" :src="item" />
                    </a-card>
                  </a-tooltip>
                </a-col>
              </a-row>
            </div>
          </a-col>
          <a-col class="gutter-row" :span="16">
            <div>
              <h3>{{ product.name }}</h3>
              <a-tooltip v-if="product.discount" :title="'If you order 10 or more copies of you get 25% off on your order.'">
                <a-badge :dot="true" color="gold">
                  <h5>${{ formatPrice(product.price) }}</h5>
                </a-badge>
              </a-tooltip>
              <h5 v-else>${{ formatPrice(product.price) }}</h5>

              <div style="margin-top: 1rem" class="d-flex flex-column">
                <span>Quantity</span>
                <a-input-number id="inputNumber" v-model="quantity" :min="1" :max="100" style="min-width: 180px" />
              </div>

              <p style="margin-top: 1rem; min-height: 120px" v-html="product.description"></p>

              <a-button type="primary" @click="openCheckout" size="large" style="margin-top: 1rem"> Checkout </a-button>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </a-spin>

    <a-modal title="Order Summary" centered :visible="isOrderVisible" :closable="false">
      <template slot="footer">
        <a-button key="back" @click="isOrderVisible = false"> Cancel </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="doCheckout"> Place your order </a-button>
      </template>

      <a-descriptions :title="null" :column="1" bordered>
        <a-descriptions-item :label="'Subtotal (' + quantity + ' items)'"> ${{ formatPrice(quantity * product.price - discount) }} </a-descriptions-item>
        <a-descriptions-item label="Delivery"> Free </a-descriptions-item>
        <a-descriptions-item label="Tax"> $0.00 </a-descriptions-item>
        <a-descriptions-item label="Shipping Address"> {{ shippingAddress }} </a-descriptions-item>
        <!-- <a-descriptions-item label="Total">
          ${{(quantity * product.price - discount).toFixed(2)}}
        </a-descriptions-item> -->
      </a-descriptions>

      <div class="p-2" style="width: 240px">
        <span>Coupon(optional)</span>
        <a-input v-model="coupon" placeholder="Please input a coupon code" />
      </div>
    </a-modal>

    <edit-shipping-info v-if="isShippingVisible" @onClose="isShippingVisible = false"></edit-shipping-info>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { get, isEmpty } from 'lodash';
import ProductService from '@/services/ProductService';
import EditShippingInfo from '@/components/EditShippingInfo';
export default {
  data() {
    return {
      product: {},
      quantity: 1,
      coupon: null,
      isOrderVisible: false,
      isShippingVisible: false,
      loading: false,
    };
  },
  components: {
    EditShippingInfo,
  },
  computed: {
    ...mapState(['user']),
    discount() {
      const discount = this.product.discount;

      if (!discount || this.quantity < discount.minimum_quantity) {
        return 0;
      }

      return (discount.in_price ? discount.in_price : this.product.price * discount.in_percent) * this.quantity;
    },
    shippingAddress() {
      const shippingInfo = this.user.user.shippingInfo;
      if (isEmpty(shippingInfo)) {
        return;
      }

      return ['address1', 'address2', 'city', 'state', 'zipcode']
        .map(attr => shippingInfo[attr])
        .filter(v => !!v)
        .join(' ');
    },
  },
  async mounted() {
    await this.doInitData();
  },
  methods: {
    async openCheckout() {
      const shippingInfo = this.user.user.shippingInfo;
      if (isEmpty(shippingInfo)) {
        this.isShippingVisible = true;
      } else {
        this.isOrderVisible = true;
      }
    },
    async doCheckout() {
      this.loading = true;
      try {
        await ProductService.doCheckout(this.product.id, this.quantity, this.coupon);
        this.$notification['success']({
          message: 'Thanks for shopping with us!',
          description: 'We emailed order details, please check your inbox.',
        });

        this.$router.push({ name: 'orderProducts' });
      } catch (err) {
        this.$notification['error']({
          message: "Sorry, we can't complete your order!",
          description: get(err, 'response.data.error', err.message),
        });
      } finally {
        this.loading = false;
      }
    },
    async doInitData() {
      try {
        const resp = await ProductService.getProduct(this.$route.params.id);
        this.product = resp;
        if (!this.product.images) {
          this.product.images = new Array(4).fill(this.product.thumbnail);
        }

        if (['EBCPRINT', 'EBCEBOOK'].includes(this.product.sku)) {
          this.product.discount = {
            minimum_quantity: 10,
            in_percent: 0.25,
          };
        }
      } catch (err) {
        this.$router.push({ name: 'orderProducts' });
      }
    },
    formatPrice(price) {
      return price ? price.toFixed(2) : '';
    },
  },
};
</script>
<style lang="scss">
.product-checkout {
  padding: 16px;

  .store > .ant-card-body {
    background: #e2f5ff !important;
  }

  .product-container {
    .ant-card {
      max-width: 240px;
      margin: 0 auto;
    }

    .product-preview {
      padding-top: 1rem;

      max-width: 320px;
      margin: 0 auto !important;
      text-align: center;

      .ant-card {
        max-width: 60px;
      }
    }
  }
}
</style>
